import React from "react";
import { motion } from "framer-motion";
import InfoColumn from "./InfoColumn";

const AboutSection = () => {
    return (
        <section className="flex flex-col items-center px-5 pt-48 w-full">
            <div className="w-full max-w-screen-xl">
                <motion.header className="flex flex-col items-center mb-20 text-center" 
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    <h1 className="mb-6 text-5xl font-bold text-black leading-[50.4px] max-w-[628px] max-md:text-4xl max-sm:text-3xl">
                        Discover iExcel International English
                    </h1>
                    <p className="text-lg leading-7 text-black max-w-[565px] max-md:text-base max-sm:text-base">
                        At iExcel, we empower students with essential English skills for
                        success.
                    </p>
                </motion.header>

                <div className="flex gap-6 justify-between max-md:flex-col max-md:items-center">
                    <InfoColumn
                        icon="ti-book"
                        title="Our Mission"
                        description="To empower students with the English language skills necessary for academic success and effective communication in a globalized world. We strive to create a supportive learning environment."
                    />

                    <InfoColumn
                        icon="ti-star"
                        title="Our Values"
                        description="We are committed to excellence in education, dedicated to student success, and respect diverse learning needs. Our flexible programs ensure accessibility for all students."
                    />

                    <InfoColumn
                        icon="ti-user"
                        title="Meet Our Team"
                        description="Our experienced instructors are dedicated to helping students excel in their academic pursuits and gain confidence in English communication."
                    />
                </div>
            </div>

        </section>
    );
};

export default AboutSection;